<template>
  <div class="home">
    <div class="container">
      <div class="content">
        <div class="success">
          <img src="@/assets/success-icon.png" alt="" />
          <h1>{{ $t("rechargeSuccess") }}</h1>
          <p>{{ $t("pleaseCheck") }}</p>
          <router-link to="/" class="button">{{ $t("resultBtn") }}</router-link>
          <p class="question">{{ $t("someQuestions") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "Success",
  created() {
    if (Cookies.get("platform") === "sdk") {
      window.location.href =
        "http://www.yulgangglobal.com/page/sdk/sdkpay/index.html#/result";
    }

    console.log("ss");
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 961px) {
  .container {
    width: 1177px;
    min-height: 724px;
    background: url(~@/assets/border-bg.png) no-repeat left top / 100% 100%;
    margin: 594px auto 100px auto;
    padding: 45px 45px 50px 45px;
    box-sizing: border-box;
    .content {
      width: 100%;
      min-height: 620px;
      background: url(~@/assets/inner-bg.jpg) no-repeat left top / 100% 100%;
      padding: 64px 50px;
      box-sizing: border-box;
      padding: 50px 160px 124px 160px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      .success {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        h1 {
          color: #ef8d18;
          font-size: 40px;
          text-align: center;
          padding: 10px 0;
        }
        &.fail {
          h1 {
            color: #618594;
          }
        }
        p {
          font-size: 20px;
          text-align: center;
          padding: 10px 0;
          color: #c2aa8b;
        }
        p.question {
          color: #697275;
          padding-top: 20px;
        }
        .button {
          width: 253px;
          height: 47px;
          text-align: center;
          line-height: 47px;
          color: #fff;
          font-size: 18px;
          font-weight: bold;
          background: url(~@/assets/success-btn.png);
          margin-top: 20px;
          cursor: pointer;
        }
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .container {
    width: 96%;
    min-height: 500px;
    background: url(~@/assets/border-bg-mobile.png) no-repeat left top / 100%
      100%;
    margin: 200px auto 100px auto;
    padding: 15px 10px 15px 10px;
    box-sizing: border-box;
    .content {
      width: 100%;
      min-height: 566px;
      background: url(~@/assets/inner-bg-mobile.jpg) no-repeat left top / 100%
        100%;
      padding: 16px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      .success {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        h1 {
          color: #ef8d18;
          font-size: 20px;
          text-align: center;
          padding: 5px 0;
        }
        &.fail {
          h1 {
            color: #618594;
          }
        }
        p {
          font-size: 14px;
          color: #ef8d18;
          text-align: center;
          padding: 5px 0;
        }
        p.question {
          color: #697275;
          padding-top: 20px;
        }
        .button {
          width: 180px;
          height: 34px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          line-height: 34px;
          background: url(~@/assets/success-btn.png) no-repeat left top / 100%
            100%;
          margin-top: 10px;
          cursor: pointer;
        }
        &.fail {
          .button {
            background: url(~@/assets/fail-button.png) no-repeat left top / 100%
              100%;
          }
        }
      }
    }
  }
}
</style>
